import * as _ from "lodash";
import { doesItemMatch } from "./doesMatch";
var FilterArraysHandler = /** @class */ (function () {
    function FilterArraysHandler() {
        this.filters = {};
        this.activeFilters = {};
    }
    FilterArraysHandler.prototype.updateFilterValue = function (filterFieldName, filterValue) {
        if (!this.filters[filterFieldName]) {
            this.filters[filterFieldName] = {};
        }
        this.filters[filterFieldName].value = filterValue;
        var hasValue = IsValidValueOrArray(filterValue);
        this.activeFilters[filterFieldName] = hasValue;
    };
    FilterArraysHandler.prototype.registerFilter = function (filterFieldName, options) {
        this.filters[filterFieldName] = {
            options: options,
            value: null
        };
    };
    FilterArraysHandler.prototype.runFilter = function (item) {
        var _this = this;
        var activeFilters = Object.entries(this.activeFilters).filter(function (a) { return a[1]; });
        if (!activeFilters.length) {
            return true;
        }
        var results = activeFilters.map(function (_a) {
            var filterFieldName = _a[0];
            var filterObject = _this.filters[filterFieldName];
            var doesItMatch = doesItemMatch(item, filterFieldName, filterObject);
            return doesItMatch;
        });
        var doesMatch = results.reduce(function (acc, match) { return acc || match; }, false);
        return doesMatch;
    };
    return FilterArraysHandler;
}());
export function IsValidValueOrArray(input) {
    if (_.isNil(input)) {
        return false;
    }
    if (!_.isArray(input)) {
        return true;
    }
    var someValues = input.some(function (v) { return !_.isNil(v); });
    if (someValues) {
        return true;
    }
    return false;
}
export default FilterArraysHandler;
